// hooks/useSubmitReview.js
import { useState } from 'react';
import { toast } from 'react-toastify';
import Axios from '../utils/axiosInstance';

export const useSubmitReview = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const submitReview = async (reviewData) => {
    setLoading(true);
    setError(null);
    try {
      const apiUrl = `${process.env.REACT_APP_API_BASE_URL}reviews/submit-review`;
      const response = await Axios.post(apiUrl, reviewData);

      if (response.status === 200 || response.status === 201) {
        toast.success("Review submitted successfully!");
        return { success: true };
      } else {
        throw new Error(response.data.message || "Submission failed");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "An error occurred.");
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return { submitReview, loading, error };
};
